import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import axios from 'axios';
import baseURL from '../../config';
import {
  Box,
  Button,
  IconButton,
  Modal,
  Pagination,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Tooltip,
  Typography
} from '@mui/material';
import { FaEdit, FaFileAlt } from 'react-icons/fa';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const CrewList = () => {
  const { id: vesselOwnerId } = useParams();
  const [crewProfiles, setCrewProfiles] = useState([]);
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedDocument, setSelectedDocument] = useState([]);
  const itemsPerPage = 10; // Define your items per page
  const navigate = useNavigate();

  useEffect(() => {
    const fetchCrewList = async () => {
      setLoading(true);
      try {
        const token = localStorage.getItem("token");
        const response = await axios.get(`${baseURL}/api/vesselownercrew/getCrewMemberById/${vesselOwnerId}`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        console.log("crewlist", response.data.data);

        if (response.data && response.data.data) {
          setCrewProfiles(response.data.data);
          setTotalPages(Math.ceil(response.data.data.length / itemsPerPage));
        } else {
          setCrewProfiles([]);
          setTotalPages(1);
        }
      } catch (err) {
        console.error("Error fetching crew list:", err);
        setCrewProfiles([]);
      } finally {
        setLoading(false);
      }
    };

    if (vesselOwnerId) {
      fetchCrewList();
    }
  }, [vesselOwnerId]);

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const handleDocumentClick = (profile) => {
    const documents = [];

    Object.entries(profile).forEach(([key, value]) => {
      if (
        key.toLowerCase().includes("document") &&
        value &&
        typeof value === "object" &&
        value.filePath
      ) {
        documents.push({
          fileName:
            value.originalName ||
            key.replace("Document", "").charAt(0).toUpperCase() +
            key.replace("Document", "").slice(1),
          filePath: `${baseURL}/${value.filePath.replace(/\\/g, "/")}`, // Normalize path for browser
          keyName: key
        });
      }
    });

    setSelectedDocument(documents);
    setModalOpen(true);
  };


  const handleEdit = (profile) => {
    navigate(`/VesselOwnerLayouts/${vesselOwnerId}/crew/add`, {
      state: { profile }
    });
  };
  
  // const GenerateResume = (profileId) => {
  //   console.log("Generating Allianz CV for profile ID:", profileId);
  // };

  // const GenerateZMIResume = (profileId) => {
  //   console.log("Generating ZMI CV for profile ID:", profileId);
  // };

  // Calculate displayed items based on pagination
  const displayedProfiles = crewProfiles.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  return (
    <div>
      {loading ? (
        <Box display="flex" justifyContent="center" p={4}>
          <Typography>Loading crew data...</Typography>
        </Box>
      ) : (
        <Paper>
          <Table sx={{ borderRadius: "8px" }}>
            <TableHead sx={{ backgroundColor: "#1976D2", height: "30px", borderRadius: "8px" }}>
              <TableRow>
                <TableCell sx={{ color: "white", fontWeight: "bold" }}>
                  <Typography sx={{ color: "white", fontWeight: "bold" }}>Sr. No.</Typography>
                </TableCell>
                <TableCell sx={{ color: "white", fontWeight: "bold" }}>Personal Info</TableCell>
                <TableCell sx={{ color: "white", fontWeight: "bold" }}>Info</TableCell>
                <TableCell sx={{ color: "white", fontWeight: "bold" }}>Documents</TableCell>
                <TableCell sx={{ color: "white", fontWeight: "bold" }}>Edit</TableCell>
                {/* <TableCell sx={{ color: "white", fontWeight: "bold" }}>Action</TableCell> */}
              </TableRow>
            </TableHead>
            <TableBody>
              {displayedProfiles.length > 0 ? (
                displayedProfiles.map((profile, index) => (
                  <TableRow key={profile._id}>
                    <TableCell sx={{ fontSize: "0.85rem", padding: "5px" }}>
                      {index + 1 + (currentPage - 1) * itemsPerPage}
                    </TableCell>
                    <TableCell sx={{ padding: "5px" }}>
                      <Typography sx={{ fontSize: "0.85rem" }}>
                        <strong>Name:</strong> {profile.name
                          .toLowerCase()
                          .replace(/\b\w/g, (char) => char.toUpperCase())}
                      </Typography>
                      <Typography sx={{ fontSize: "0.85rem" }}><strong>Indos No:</strong> {profile.indosno}</Typography>
                      <Typography sx={{ fontSize: "0.85rem" }}><strong>Email:</strong> {profile.email}</Typography>
                      <Typography sx={{ fontSize: "0.85rem" }}><strong>Mobile No.:</strong> {profile.mobile}</Typography>
                    </TableCell>

                    <TableCell>
                      <Typography sx={{ fontSize: "0.85rem" }}><strong>Rank Name:</strong> {profile.rankname}</Typography>
                      <Typography sx={{ fontSize: "0.85rem" }}><strong>Purpose:</strong> {profile.purpose}</Typography>
                      <Typography sx={{ fontSize: "0.85rem" }}><strong>CDC:</strong> {profile.cdc}</Typography>
                      <Typography sx={{ fontSize: "0.85rem" }}><strong>COC:</strong> {profile.coc}</Typography>
                      <Typography sx={{ fontSize: "0.85rem" }}><strong>CVC Category:</strong> {profile.cvcategory}</Typography>
                    </TableCell>
                    <TableCell sx={{ fontSize: "0.85rem", padding: "5px" }}>
                      {profile &&
                        Object.keys(profile).some((key) =>
                          key.toLowerCase().includes("document") && profile[key] !== null
                        ) ? (
                        <IconButton onClick={() => handleDocumentClick(profile)}>
                          <PictureAsPdfIcon sx={{ color: "red" }} />
                        </IconButton>
                      ) : (
                        <Typography variant="body2" color="textSecondary">
                          No Document Available
                        </Typography>
                      )}
                    </TableCell>

                    <TableCell sx={{ fontSize: "0.85rem", padding: "5px" }}>
                      <IconButton onClick={() => handleEdit(profile)} sx={{ color: "blue", "&:hover": { color: "darkblue" } }}>
                        <FaEdit />
                      </IconButton>
                    </TableCell>
                    {/* <TableCell sx={{ fontSize: "0.85rem", padding: "5px" }}>
                      <Tooltip title="Download Allianz CV">
                        <IconButton onClick={() => GenerateResume(profile._id)}>
                          <FaFileAlt />
                        </IconButton>
                      </Tooltip>

                      <Tooltip title="Download ZMI CV">
                        <IconButton onClick={() => GenerateZMIResume(profile._id)}>
                          <FaFileAlt />
                        </IconButton>
                      </Tooltip>
                    </TableCell> */}
                  </TableRow>
                ))
              ) : (
                <TableRow>
                  <TableCell colSpan={6} sx={{ fontSize: "0.85rem", padding: "5px" }}>
                    <Typography align="center">No crew profiles found</Typography>
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </Paper>
      )}

      {/* Pagination Controls */}
      {crewProfiles.length > 0 && (
        <Box mt={4} display="flex" justifyContent="center">
          <Pagination
            count={totalPages}
            page={currentPage}
            onChange={(event, page) => handlePageChange(page)}
            variant="outlined"
            shape="rounded"
          />
        </Box>
      )}
      <ToastContainer />

      {/* PDF Modal */}
      <Modal open={modalOpen} onClose={() => setModalOpen(false)}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: { xs: "90%", sm: "60%", md: "50%" },
            maxHeight: "80vh",
            bgcolor: "white",
            boxShadow: 24,
            p: 3,
            borderRadius: 2,
            overflowY: "auto",
          }}
        >
          <Typography
            variant="h6"
            gutterBottom
            sx={{ textAlign: "center", mb: 2, fontWeight: "bold" }}
          >
            Crew Documents
          </Typography>

          {selectedDocument && selectedDocument.length > 0 ? (
            selectedDocument.map((doc, index) => (
              <Paper
                key={index}
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  p: 2,
                  mb: 2,
                  boxShadow: 2,
                  borderRadius: 2,
                  transition: "0.3s",
                  "&:hover": { boxShadow: 4, bgcolor: "#f5f5f5" },
                }}
              >
                <Box display="flex" alignItems="center">
                  <PictureAsPdfIcon sx={{ color: "red", mr: 1 }} />
                  <Typography variant="body1">{doc.fileName}</Typography>
                </Box>
                <Button
                  variant="contained"
                  color="primary"
                  href={doc.filePath}
                  target="_blank"
                  rel="noopener noreferrer"
                  size="small"
                  sx={{ textTransform: "none" }}
                >
                  Download
                </Button>
              </Paper>
            ))
          ) : (
            <Typography align="center" color="textSecondary">
              No documents available
            </Typography>
          )}

          <Box display="flex" justifyContent="center" mt={2}>
            <Button variant="contained" color="error" onClick={() => setModalOpen(false)}>
              Close
            </Button>
          </Box>
        </Box>
      </Modal>

    </div>
  );
};

export default CrewList;